import { SearchBarFilterType } from '../searchbar.types.js';
import Color from 'color';

const searchBarValueToFabricFilters = (searchBarValue) => {
  const tagIds = [];
  const kinds = [];
  const ancestorIds = [];
  let color;
  try {
    color = searchBarValue.color ? new Color(searchBarValue.color).rgb().array() : void 0;
  } catch {
  }
  for (const filter of searchBarValue.filters) {
    if (!filter.value?.value) continue;
    if (filter.type === SearchBarFilterType.TAG) {
      tagIds.push(filter.value.value);
    } else if (filter.type === SearchBarFilterType.CONTENT_TYPE) {
      kinds.push(filter.value.value);
    } else if (filter.type === SearchBarFilterType.LOCATION) {
      ancestorIds.push(filter.value.value);
    }
  }
  return {
    tagIds: tagIds.length ? tagIds : void 0,
    kinds: kinds.length ? kinds : void 0,
    ancestorIds: ancestorIds.length ? ancestorIds : void 0,
    color
  };
};

export { searchBarValueToFabricFilters };
//# sourceMappingURL=converters.js.map
